import RenderReactCol from './RenderReactCol';

export default RenderReactCol;
